import { Grid } from "@mui/system";
import { Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import DecreaseDailyIncomeTable, {
  DECREASE_DAILY_INCOME_COLUMNS,
} from "./DecreaseDailyIncomeTable";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";
import BrandSearchBar from "../Utils/BrandSearchBar";

const DecreaseDailyIncome = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const decreaseDailyIncomeData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.decreaseDailyIncomeData,
  );

  const decreaseDailyIncomeMetadata = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.decreaseDailyIncomeMetadata,
  );

  const isFetchedForIncomeData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForIncomeData,
  );

  //-- Extract unique brand names for the search filter (this query uses
  //   brand_name).
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (decreaseDailyIncomeData || []).forEach((r: any) => {
      if (typeof r?.brand_name === "string") set.add(r.brand_name.trim());
    });
    return Array.from(set);
  }, [decreaseDailyIncomeData]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return decreaseDailyIncomeData;
    return (decreaseDailyIncomeData || []).filter((row: any) =>
      String(row.brand_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [decreaseDailyIncomeData, choosenBrand]);

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        px={2}
        py={1.5}
        sx={{ borderTop: "1px solid #0000001F" }}
      >
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Decrease in Daily Income in MTD
          </Typography>
        </Grid>
        <Grid size={4}>
          <BrandSearchBar
            dataTrackerForSearch="885"
            brandNames={brandNames}
            chosenBrand={choosenBrand}
            onBrandChange={setChosenBrand}
            dataTrackerForDownload="883"
            onDownload={() =>
              exportRowsToCsv(
                filteredData,
                DECREASE_DAILY_INCOME_COLUMNS,
                "decrease-daily-income-mtd.csv",
              )
            }
            disabled={
              (decreaseDailyIncomeData?.length ?? 0) === 0 ||
              !isFetchedForIncomeData
            }
          />
        </Grid>
      </Grid>
      <DecreaseDailyIncomeTable
        metadata={decreaseDailyIncomeMetadata}
        rows={filteredData}
      />
    </>
  );
};

export default DecreaseDailyIncome;
